import { el, sv, VNode } from "@dhx/ts-common/dom";
import { IGroup, IGroupConfig } from "@dhx/ts-diagram";
import locale from "../../locales/en";
import { getMeta } from "../../helpers/baseMetaInfo";
import { ShapesCollection } from "../../ShapesCollection";
import { getGroupContainerStyle } from "../templates/templates";
import { BaseGroup } from "./BaseGroup";

export class Group extends BaseGroup implements IGroup {
	public config: IGroupConfig;
	protected data: ShapesCollection;

	constructor(config: IGroupConfig, params) {
		super(config, params);
	}
	protected setDefaults(config: IGroupConfig): IGroupConfig {
		config.width = config.width || 300;
		config.height = config.height || 200;

		this.setServiceProp(config);
		super.setDefaults(config);

		return config;
	}
	public getMetaInfo(): { [key: string]: string }[] {
		let meta = [
			{ type: "grid", label: locale.gridStep },
			{ type: "arrangeGroup", label: locale.arrange },
			{ type: "fillGroup", label: locale.fill },
			{ type: "strokeGroup", label: locale.stroke },
		];
		if (this.config.header) {
			const header = [
				{ type: "headerText", label: locale.headerText },
				{ type: "headerStyle", label: locale.headerStyle },
				{ type: "headerFill", label: locale.headerFill },
				{ type: "headerPosition", label: locale.headerPosition },
			];
			if (this.config.header.enable) {
				meta = [...meta, ...header];
			}
			meta.push({ type: "headerEnable", label: locale.headerEnable });
		}
		return getMeta(meta);
	}
	public render(): VNode {
		this.setServiceProp(this.config);

		const { id, header, $width, $height } = this.config;

		let currentCss = "dhx_diagram_item dhx_diagram_group ";
		if (header?.enable) {
			currentCss += `dhx_diagram_group--position_${header.position}`;
		}

		const htmlChildren = this.getChildHtmlNodes(this.config, this.data);
		const svgChildren = this.getChildSvgNodes(this.config, this.data);

		return el(
			"div",
			{
				_key: id,
				dhx_id: id,
				class: `${currentCss} ${this.getCss()}`,
				style: getGroupContainerStyle(this.config, this.getCoords(this.config)),
			},
			[
				el("div.dhx_diagram_group__children", [
					sv(
						"svg.dhx_diagram_group__children",
						{
							xmlns: "http://www.w3.org/2000/svg",
							reserveAspectRatio: "none",
							width: $width,
							height: $height,
						},
						svgChildren
					),
					...htmlChildren,
				]),
				header?.enable && this.getGroupHeader(this.config, this.getEditorNode()),
			]
		);
	}
}
